import React from "react";

export default function TicketProgress({ section }) {
  const total = Number(section.ticket_quantity);
  const remaining = Number(section.ticket_balance);
  const known =
    Number.isFinite(total) && total > 0 && Number.isFinite(remaining);
  const percent = known
    ? Math.round((1 - Math.min(total, Math.max(0, remaining)) / total) * 100)
    : null;

  return (
    <div className="mw-ticket-progress">
      <span>
        {percent === null
          ? "Борлуулалтын мэдээлэл хүлээгдэж байна"
          : `Борлуулалт ${percent}%`}
      </span>
      <div
        className="mw-ticket-progress-track"
        role="progressbar"
        aria-label={`${
          section.section_name || "Megawin"
        } тасалбарын борлуулалт`}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent === null ? undefined : percent}
        aria-valuetext={
          percent === null ? "Мэдээлэл хүлээгдэж байна" : `${percent}%`
        }
      >
        <div
          className="mw-ticket-progress-fill"
          style={{ width: `${percent || 0}%` }}
        />
      </div>
    </div>
  );
}
